import { placeholdersIn, toBody } from '../connectorConfig';
import { toolToBody } from '../connectorToolConfig';
import { placeholderKind, probeInputsFor } from './placeholders';

// Which step holds the field an error from formErrors is about.
const STEP_OF = {
  capability: 'capability',
  url: 'request',
  headers: 'request',
  body: 'request',
  authHeader: 'request',
  authParam: 'request',
  map: 'rows',
  filter: 'rows',
  errorWhenPath: 'rows',
  errorWhenValue: 'rows',
  timeoutMs: 'safety',
  rateLimitPerMinute: 'safety',
};
const TOOL_STEP_OF = {
  argRows: 'request',
  argCount: 'request',
  maxRows: 'safety',
  maxTextChars: 'safety',
  personal: 'safety',
};

export const errorList = (errors) => [
  ...Object.entries(errors)
    .filter(([key]) => key !== 'tool')
    .map(([key, message]) => ({ step: STEP_OF[key] || 'request', message })),
  ...Object.entries(errors.tool || {}).map(([key, message]) => ({
    step: TOOL_STEP_OF[key] || 'agent',
    message: key === 'argRows' ? 'An argument needs fixing.' : message,
  })),
];

// The tool the probe validates arguments against; a capability's arguments come from its handler.
export const toolOf = (form) => (form.mode === 'tool' ? toolToBody(form.tool) : null);

export const stepsDone = (form, argNames, contract) => ({
  capability: !!form.capability,
  request:
    /^https:\/\/[^/]/.test(form.url.trim()) &&
    placeholdersIn(form.url).every((name) => placeholderKind(name, argNames) !== 'unknown'),
  rows:
    form.mode === 'tool'
      ? form.mapRows.some((row) => row.key.trim() && row.value.trim())
      : !!contract &&
        (contract.resultFields || [])
          .filter((field) => field.required)
          .every((field) => form.mapRows.some((row) => row.key.trim() === field.name && row.value.trim())),
  agent:
    !!form.tool.name.trim() &&
    !!form.tool.description.trim() &&
    form.tool.argRows.every((row) => row.description.trim()),
  safety: true,
});

export const snapshotOf = (form, values) =>
  JSON.stringify({ body: toBody(form), inputs: probeInputsFor(form, toolOf(form), values) });
